import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType as NewEventType } from "@/features/events/types/EventType"
import CloseButton from "@/pages/new-platform/components/CloseButton"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import PrimaryButton from "../../../../components/buttons/PrimaryButton"
import { saveEvent } from "../../../../utils/apis/user-service"
import { EventType } from "../../../../utils/enums/EventType"
import { useAuthStore } from "../../../../utils/stores/useAuthStore"
import { useUserStore } from "../../../../utils/stores/useUserStore"

const Packing = () => {
    const { sendEvent } = useCreateEvent()
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const { userData } = useUserStore()
    const email = userData.email
    const navigate = useNavigate()

    const onConfirmClick = async () => {
        if (!email) return
        navigate("/dna-test/request-pickup")
        saveEvent(
            email,
            EventType.DnaPackingButtonClicked,
            (success) => { console.log() },
            (error) => { console.log(error) },
            "dna_packing_page",
        )
        await sendEvent({
            event: NewEventType.BUTTON_CLICK,
            sub_category: "action_button",
            event_metadata: { action: "confirm_dna_test_packing" }
        })
    }

    useEffect(() => {
        if (!email || !idToken) return
        saveEvent(
            email,
            EventType.PageView,
            (success) => { console.log() },
            (error) => { console.log(error) },
            "dna_packing_page",
        )

        void sendEvent({
            event: NewEventType.PAGE_VIEW,
            sub_category: "dna_test_packing_page",
        })
    }, [])

    return (
        <div className="w-full h-full flex flex-col flex-shrink-0">
            <div className="w-full my-[10px] flex justify-end flex-shrink-0">
                <CloseButton
                    onClick={() => navigate("/dna-test")}
                />
            </div>
            <div className="font-bold text-[25px] leading-[33px] mt-[10px] mb-[20px] flex-shrink-0">
                Impacchetta il tuo test
            </div>
            <div className="flex-1 flex flex-col justify-between font-normal text-[16px] leading-[26px]">
                <div className="space-y-[30px]">
                    <div>
                        <div className="font-bold">
                            1. Compila i due sticker codice campione:
                        </div>
                        <ul className="list-disc ml-[20px]">
                            <li>Indica data e orario di prelievo.</li>
                            <li>Incolla uno sticker sulla tua Member's Card.<br />(👉 Tienila con te, non spedirla.)</li>
                            <li>Incolla il secondo sticker sulla provetta.</li>
                        </ul>
                    </div>
                    <div>
                        <div className="font-bold">
                            2. Prepara la spedizione:
                        </div>
                        <ul className="list-disc ml-[20px]">
                            <li>
                                Inserisci la provetta nella busta rinforzata/biohazard.
                            </li>
                            <li>
                                Chiudi la busta e inseriscila nella busta del corriere.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="mb-[20px] md:mb-[50px] w-full space-y-[10px] justify-between md:space-y-0 md:space-x-[10px] md:flex md:flex-row md:items-center">
                    <div className="w-full h-[50px] flex-shrink-0 md:w-[49%]">
                        <PrimaryButton
                            text="Fatto! Avanti"
                            pointer={true}
                            disabled={false}
                            fontSize={16}
                            onClick={onConfirmClick}
                        />
                    </div>
                    {/* <div className="w-full h-[50px] flex-shrink-0 md:w-[49%]">
                        <WhiteButton
                            text="Indietro"
                            pointer={true}
                            fontSize={16}
                            onClick={() => navigate("/diagnostica/tests-and-reports/dna-test")}
                            uppercase={false}
                        />
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default Packing
